// Robinhood Chain network parameters.
// Verify against https://docs.robinhood.com/chain/add-network-to-wallet/ before any mainnet enablement.
export const robinhoodTestnet = {
    id: 46630,
    name: 'Robinhood Chain Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.testnet.chain.robinhood.com'] },
    },
    blockExplorers: {
        default: { name: 'Blockscout', url: 'https://explorer.testnet.chain.robinhood.com' },
    },
    testnet: true,
};

export const robinhoodMainnet = {
    id: 4663,
    name: 'Robinhood Chain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.mainnet.chain.robinhood.com'] },
    },
    blockExplorers: {
        default: { name: 'Blockscout', url: 'https://robinhoodchain.blockscout.com' },
    },
};

// Mainnet contract is live and functional (verified via direct RPC reads).
// Minting itself stays gated by the contract's own mintingActive/ogMintEnabled
// flags, controlled by the treasury wallet via the admin console -- flipping
// this frontend flag only makes the mainnet chain/contract selectable, it does
// not open minting on its own.
export const ROBINHOOD_MAINNET_ENABLED = true;
export const PUBLIC_MINT_ENABLED = true;

// Single source of truth for "which network is this deployment targeting" --
// every component that needs a chain ID, RPC, or network name should read
// this instead of hardcoding robinhoodTestnet.
export const activeChain = ROBINHOOD_MAINNET_ENABLED ? robinhoodMainnet : robinhoodTestnet;
